import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import Label from '../../MUIComponents/Label';
import { LabelTypeEnum } from '../../../enums/label-enum';
import { useGetIndustriesQuery } from '../../../store/apiSlice/jobpost/jobpostApi';
import CheckIcon from '@mui/icons-material/Check';
import JobPostsCompanyLogo from '../../../pages/JobPostsPage/components/JobPostsList/JobPostsCompanyLogo';
import JobPostsCompanyStatistics from '../../../pages/JobPostsPage/components/JobPostsList/JobPostsCompanyStatistics';
import { ICompanyUser } from '../../../interfaces/jobpost.interface';

interface JobPostApplyEmployerInfoProps {
  companyUser: ICompanyUser;
}

const JobPostApplyEmployerInfo: React.FC<JobPostApplyEmployerInfoProps> = ({
  companyUser,
}) => {
  const { data: sportsIndustries } = useGetIndustriesQuery();

  const renderCompanyIndustries = (industryIds: string[] | undefined) => {
    if (
      sportsIndustries &&
      sportsIndustries?.length > 0 &&
      industryIds &&
      industryIds.length > 0
    ) {
      const companyIndustriesWithId = sportsIndustries.filter((industry) =>
        industryIds.includes(industry.id)
      );

      return companyIndustriesWithId.map((industry, idx) => (
        <span key={industry.id}>
          {industry.industry}
          {idx !== companyIndustriesWithId?.length - 1 && ', '}
        </span>
      ));
    }
    return '';
  };
  return (
    <Box
      sx={{
        width: '100%',
        p: '22px 16px',
      }}
    >
      <Stack
        direction={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        spacing={'10px'}
        sx={{
          width: '100%',
          borderBottomWidth: '1px',
          borderBottomColor: 'background.dark',
          borderBottomStyle: 'solid',
          pb: '28px',
        }}
      >
        <JobPostsCompanyLogo
          url={companyUser.media?.avatar?.fileUrl}
          height={70}
        />

        <Typography textTransform={'uppercase'} variant="badge2">
          {companyUser.company?.companyName || ''}
        </Typography>
      </Stack>
      <Stack
        mt={'28px'}
        mb={'28px'}
        direction={'row'}
        justifyContent={'space-between'}
      >
        <Typography variant="h3" color={'text.primary'} textAlign={'left'}>
          About employer
        </Typography>
        <Label
          sx={{
            display: 'flex',
            gap: '4px',
            alignItems: 'center',
            fontSize: '8px',
          }}
          labelType={
            companyUser.verified
              ? LabelTypeEnum.VERIFIED
              : LabelTypeEnum.UNDER_VERIFICATION
          }
        >
          {companyUser.verified && <CheckIcon sx={{ width: 11, height: 11 }} />}
          {companyUser.verified
            ? LabelTypeEnum.VERIFIED
            : LabelTypeEnum.UNDER_VERIFICATION.replace(/_/g, ' ')}
        </Label>
      </Stack>

      <Stack component={'ul'} spacing={'22px'}>
        <Box component={'li'}>
          <Typography component={'p'} fontSize={'12px'} fontWeight={700}>
            Location:
          </Typography>
          <Typography variant="body3">
            {companyUser.company?.country || ''}
            {companyUser.company?.country && companyUser.company?.city
              ? ', '
              : ''}
            {companyUser.company?.city || ''}
          </Typography>
        </Box>
        <Box component={'li'}>
          <Typography component={'p'} fontSize={'12px'} fontWeight={700}>
            Industry:
          </Typography>
          <Typography variant="body3">
            {renderCompanyIndustries(companyUser.company?.industryIds)}
          </Typography>
        </Box>
        <Box component={'li'}>
          <JobPostsCompanyStatistics companyId={companyUser.id} />
        </Box>
      </Stack>
    </Box>
  );
};

export default JobPostApplyEmployerInfo;
